import React, { useState } from "react";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import Showimage from "./modalshowimage";
import ButtonDash from "../common/buttonDashboard";
const Renderbooking = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
}) => {
  const [isOpen, setisOpen] = useState(false);
  const [url, setUrl] = useState("");
  const handelClose = () => {
    setisOpen(false);
  };

  const handleClick = (url) => {
    setUrl(url);
    setisOpen(true);
  };
  //console.log(list);
  return (
    <>
      <Showimage isOpen={isOpen} onCancel={handelClose} list={url} />
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div className="row" ref={lastBookElementRef} key={item.no}>
                <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                    <div className="row ms-1">
                      <div className="container col-xs-12 col-sm-4">
                        <div
                          className="border-top"
                          style={{ fontSize: "15px" }}
                        >
                          <span className="badge rounded-pill bg-secondary">
                            {item.no}{" "}
                          </span>

                          <span> {item.name}</span>
                        </div>

                        <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                          <div className="mytooltip tooltip-effect-1">
                            <span className="tooltip-item">
                              <span
                                className="col-auto  p-0 ms-1 mb-3"
                                onClick={() => handleClick(item.url)}
                              >
                                <img
                                  className="personTooltip"
                                  src={item.url}
                                  alt=""
                                  style={{
                                    maxHeight: 150,
                                    Width: 150,
                                  }}
                                />
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="container col-xs-12 col-sm-3">
                        <div
                          className="border-top"
                          style={{ fontSize: "14px" }}
                        >
                          {"ล๊อค:"} {item.parkname}
                        </div>
                        <div
                          className="border-top"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            เดือน:{item.payfrom} - {item.payto}
                          </span>
                        </div>
                      </div>

                      <div className="container col-xs-12 col-sm-3">
                        <div
                          className="border-top"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "15px" }}>
                            {"วันที่:"}{" "}
                            <span className="badge bg-warning">
                              {item.uploaddate}
                            </span>
                          </span>
                        </div>

                        <div
                          className="border-top"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            โอนโดย:{item.byname}
                          </span>
                        </div>
                      </div>
                      <div className="container col-xs-12 col-sm-2 d-flex justify-content-end">
                        <div className="row m-1">
                          {item.appid === 0 ? (
                            <>
                              <ButtonDash
                                disabled={true}
                                value={0}
                                label={"up"}
                                className="btn btn-success"
                              />

                              <ButtonDash
                                disabled={false}
                                value={1}
                                label={"AC"}
                                onClick={() => handleOnClick(item.id,1)}
                                className="btn btn-danger"
                              />
                              <ButtonDash
                                disabled={true}
                                value={2}
                                label={"FN"}
                                className="btn btn-danger"
                              />
                            </>
                          ) : item.appid === 1 ? (
                            <>
                              {" "}
                              <ButtonDash
                                disabled={false}
                                value={0}
                                label={"up"}
                                className="btn btn-success"
                              />
                              <ButtonDash
                                disabled={false}
                                value={1}
                                label={"AC"}
                                className="btn btn-success"
                              />
                              <ButtonDash
                                disabled={false}
                                value={2}
                                label={"FN"}
                                onClick={() => handleOnClick(item.id,2)}
                                className="btn btn-danger"
                              />
                            </>
                          ) : (
                            <>
                              {" "}
                              <ButtonDash
                                disabled={false}
                                value={0}
                                label={"up"}
                                className="btn btn-success"
                              />
                              <ButtonDash
                                disabled={false}
                                value={1}
                                label={"AC"}
                                className="btn btn-success"
                              />
                              <ButtonDash
                                disabled={false}
                                value={2}
                                label={"FN"}
                                className="btn btn-success"
                              />
                            </>
                          )}
                        </div>

                        {/* <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleOnClick(item.id)}
                        >
                          ยืนยันรับเงิน
                          <FontAwesome name="edit" />
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="row" key={item.no}>
                <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                    <div className="row ms-1">
                      <div className="container col-xs-12 col-sm-4">
                        <div
                          className="border-top"
                          style={{ fontSize: "15px" }}
                        >
                          <span className="badge rounded-pill bg-secondary">
                            {item.no}{" "}
                          </span>

                          <span> {item.name}</span>
                        </div>

                        <div className="container col-xs-6 col-sm-4 col-md-2 lg-1">
                          <div className="mytooltip tooltip-effect-1">
                            <span className="tooltip-item">
                              <span
                                className="col-auto  p-0 ms-1 mb-3 "
                                onClick={() => handleClick(item.url)}
                              >
                                <img
                                  className="personTooltip"
                                  src={item.url}
                                  alt=""
                                  style={{
                                    maxHeight: 150,
                                    Width: 150,
                                  }}
                                />
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="container col-xs-12 col-sm-3">
                        <div
                          className="border-top"
                          style={{ fontSize: "14px" }}
                        >
                          {"ล๊อค:"} {item.parkname}
                        </div>
                        <div
                          className="border-top"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            เดือน:{item.payfrom} - {item.payto}
                          </span>
                        </div>
                      </div>

                      <div className="container col-xs-12 col-sm-3">
                        <div
                          className="border-top"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "15px" }}>
                            {"วันที่:"}{" "}
                            <span className="badge bg-warning">
                              {item.uploaddate}
                            </span>
                          </span>
                        </div>

                        <div
                          className="border-top"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            โอนโดย:{item.byname}
                          </span>
                        </div>
                      </div>
                      <div className="container col-xs-12 col-sm-2 d-flex justify-content-end">
                        <div className="row m-1">
                        {item.appid === 0 ? (
                            <>
                              <ButtonDash
                                disabled={true}
                                value={0}
                                label={"up"}
                                className="btn btn-success"
                              />

                              <ButtonDash
                                disabled={false}
                                value={1}
                                label={"AC"}
                                onClick={() => handleOnClick(item.id,1)}
                                className="btn btn-danger"
                              />
                              <ButtonDash
                                disabled={true}
                                value={2}
                                label={"FN"}
                                className="btn btn-danger"
                              />
                            </>
                          ) : item.appid === 1 ? (
                            <>
                              {" "}
                              <ButtonDash
                                disabled={false}
                                value={0}
                                label={"up"}
                                className="btn btn-success"
                              />
                              <ButtonDash
                                disabled={false}
                                value={1}
                                label={"AC"}
                                className="btn btn-success"
                              />
                              <ButtonDash
                                disabled={false}
                                value={2}
                                label={"FN"}
                                onClick={() => handleOnClick(item.id,2)}
                                className="btn btn-danger"
                              />
                            </>
                          ) : (
                            <>
                              {" "}
                              <ButtonDash
                                disabled={false}
                                value={0}
                                label={"up"}
                                className="btn btn-success"
                              />
                              <ButtonDash
                                disabled={false}
                                value={1}
                                label={"AC"}
                                className="btn btn-success"
                              />
                              <ButtonDash
                                disabled={false}
                                value={2}
                                label={"FN"}
                                className="btn btn-success"
                              />
                            </>
                          )}
                        </div>

                        {/* <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleOnClick(item.id)}
                        >
                          ยืนยันรับเงิน
                          <FontAwesome name="edit" />
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default Renderbooking;
